export enum CmrDocumentType {
    Doc = 0,
    Cost,
    Invoice,
}